<template>
  <div class="header-title">
    <div class="col-md-6 offset-md-3 mb-5">
      <div>
        <h1 class="h-title"><span><img src="../assets/images/logo.png" alt=""></span><span>{{officename}} 履歴書送信システム</span></h1>
        <p class="contents-introduction">案内に沿ってフォームに入力するだけで、<br>PDFファイルのJIS規格に合わせた履歴書が作成できる自動作成ツールです。</p>
      </div>
    </div>
  </div>
</template>

<script>
var SYS_OFFICENAME = process.env.VUE_APP_SYS_OFFICENAME
export default {
  name: 'Header',
  components: {
  },
  data() {
    return {
      officename: SYS_OFFICENAME
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
